<div class="filter-bar">
    <button mat-stroked-button color="primary" (click)="openFilterDialog()">
        Filter States and Level
        <vulcan-icon icon="funnel-simple"></vulcan-icon>
    </button>

    <button mat-stroked-button color="primary" (click)="openDateRangeDialog()">
        Set Run Start Time <vulcan-icon icon="calendar"></vulcan-icon>
    </button>

    <button mat-stroked-button matTooltip="Export" matTooltipPosition="above" matTooltipShowDelay="250" [matMenuTriggerFor]="menu">
        <vulcan-icon icon="export"></vulcan-icon>
    </button>
</div>

<div class="filters extra-row details">
    <p><b>Aggregation Level:</b> {{ filterGroup.value.aggregationLevel | aggregationLevel }}</p>
    <p><b>Run Start Time:</b> {{ filterGroup.value?.date | date }}</p>
</div>

<mat-menu #menu="matMenu" overlapTrigger>
    <button (click)="exportTable()" mat-menu-item>Export Table As CSV</button>
</mat-menu>

<div class="table-section">
    <mat-card>
        <mat-card-content>
            <div class="table-container">
                <table mat-table #tableSort="matSort" [dataSource]="dataSource" matSort [matSortDisableClear]="true" matSortDirection="asc">
                    <tr mat-header-row *matHeaderRowDef="columns()"></tr>
                    <tr mat-row *matRowDef="let row; columns: columns()"></tr>

                    <ng-container *matNoDataRow>
                        <td class="no-data-row" [colSpan]="columns().length">No results match your filters</td>
                    </ng-container>

                    <ng-container matColumnDef="state">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            <eaglei-table-sort-header columnName="state" [sort]="tableSort"></eaglei-table-sort-header>
                            State Name
                        </th>
                        <td mat-cell *matCellDef="let data">
                            {{ data.stateName }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="county">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            <eaglei-table-sort-header columnName="county" [sort]="tableSort"></eaglei-table-sort-header>
                            County Name
                        </th>
                        <td mat-cell *matCellDef="let data">
                            {{ data.countyName }}
                        </td>
                    </ng-container>

                    @for (outageType of outageTypes.values(); track $index) { @let columnName = outageType.name.toLowerCase();
                    <ng-container [matColumnDef]="columnName">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            <eaglei-table-sort-header [columnName]="columnName" [sort]="tableSort"></eaglei-table-sort-header>
                            {{ outageType.name | replaceCharacter }}
                        </th>
                        <td mat-cell *matCellDef="let data">
                            @if (!data.breakdownMap.has(outageType)) {
                            <span>Not Available</span>
                            } @else {
                            {{ data.breakdownMap.get(outageType) | number : '1.0-0' }}
                            }
                        </td>
                    </ng-container>
                    }
                </table>

                <mat-paginator showFirstLastButtons [pageSizeOptions]="[10, 25, 50]"></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</div>
